module.exports = __webpack_public_path__ + "static/media/somos_familia.6445ad97.png";